import React, { useEffect } from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import FeatureDisplay from "../../components/common/FeatureDisplay";
import RequestDemo from "../../components/common/RequestDemo";
import { complianceManagementFeature, complianceManagementInfo, complianceManagementProblemSolved} from "./solutionConstants";
import ProblemSolved from "../../components/sections/corporateManagement/ProblemSolved";
import complianceAnimation from '../../website animations/Compliance page animation (2) 2.json'
import { useLocation } from "react-router-dom";

const ComplianceAssurance = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('solution');
    const sectionId = location.hash.substring(1);
    const section = document.getElementById(sectionId);
    if(section){      
      window.scrollTo({
        top: section.offsetTop - 100,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
    <div id="solution" className="flex flex-col items-center justify-center gap-8 sm:gap-16">
      <HeroReuse
        Subtitle="SOLUTIONS"
        Title="Compliance Assurance"
        Description="Be compliant, stay ahead."
        // ButtonText="Request a Demo Today"
        lottie={complianceAnimation}
      />
      <FeatureDisplay infoSectionData={complianceManagementInfo} data={complianceManagementFeature} />
      <ProblemSolved features={complianceManagementProblemSolved}/>
      <RequestDemo 
       title={'Explore Compliance Management'}
      />
    </div>
  );
};

export default ComplianceAssurance;
